module.exports = __webpack_public_path__ + "img/xentral-done-illustrated.53b0be15.svg";